import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import _ from 'lodash'

import { DataSetsTable } from '../../components/data-sets-table'
import { useDataSets } from '../../stores/data-sets-store'
import type { Stores } from '../../util/store'
import { useOrganizations } from '../../stores/organization-store'

export interface DataSetsPageProps {
    stores: Stores
}

export const DataSetsPage = observer(({ stores }: DataSetsPageProps) => {
    const dataSets = useDataSets(stores)
    const organizations = useOrganizations(stores.organizations)

    const createDataSet = useCallback(
        async (name: string) => {
            await stores.dataSets.create(name)
        },
        [stores.dataSets],
    )
    const updateDataSet = useCallback(
        async (
            dataSetId: string,
            body: { name?: string; parent_data_set_id?: string | null },
        ) => {
            await stores.dataSets.update(dataSetId, body)
        },
        [stores.dataSets],
    )
    const deleteDataSet = useCallback(
        async (dataSetId: string) => {
            await stores.dataSets.delete(dataSetId)
        },
        [stores.dataSets],
    )
    const setDataSetOrganizations = useCallback(
        async (id: string, additions: string[], deletions: string[]) => {
            await Promise.allSettled([
                stores.dataSets.addOrganizationDataSets(id, additions),
                stores.dataSets.removeOrganizationDataSets(id, deletions),
            ])
        },
        [stores.dataSets],
    )

    return (
        <div data-testid="data-sets-page" style={{ display: 'contents' }}>
            <DataSetsTable
                dataSets={dataSets}
                organizations={organizations}
                rowCount={dataSets.length}
                createDataSet={createDataSet}
                updateDataSet={updateDataSet}
                deleteDataSet={deleteDataSet}
                setDataSetOrganizations={setDataSetOrganizations}
                isLoading={stores.dataSets.isFetching}
                showProgressBars={stores.dataSets.isUpdating}
                isTreeTable={true}
                isPrimaryBackgroundColor={true}
            />
        </div>
    )
})
